import { GraphQLQuery } from '@settings/services/graphQLClient/GraphQLClient';
import gql from 'graphql-tag';

// Параметры мутации на удаление продукта из избранного
export interface DeleteFavoritesProductMutationParams {
  id: string;
}

// Ответ мутации на удаление продукта из избранного
export interface DeleteFavoritesProductMutationResponse {
  data: boolean;
}

// Мутация на удаление продукта из избранного
export class DeleteFavoritesProductMutation
  implements GraphQLQuery<DeleteFavoritesProductMutationParams>
{
  readonly query: any;

  readonly variables: DeleteFavoritesProductMutationParams;

  constructor(params: DeleteFavoritesProductMutationParams) {
    this.variables = {
      ...params,
    };

    this.query = gql`
      mutation __DELETE_PRODUCT_FROM_FAVORITES__($id: ID!) {
        data: BitrixUserDeleteFavourite(favouriteID: $id)
      }
    `;
  }
}
